
import LottieAnimation from "./lottieAnimation.js";
import extractOptions from "../../utility/extractOptions.js";

export function applyToElements() {

    const lottieElements = document.querySelectorAll("[data-lottie]");
    console.log("Finding Lottie Animations ",lottieElements);
    const lottieElementsArray = Array.prototype.slice.call(lottieElements);

    lottieElementsArray.forEach(applyToElement);

} 


export function applyToElement(element) {

    const options = Object.assign(
        {},
        LottieAnimation.DEFAULTS,
        extractOptions("lottie", element)
    );
    const instance = new LottieAnimation(element, options);
    element.instance = instance;
}


// WEBPACK FOOTER //
// ./project/client/src/core/components/lottieAnimation/index.js